export interface Contributor {
  name: string;
  fullName: string;
  slug: string; // Unique owner slug used in prototype URLs (e.g. /fc/fabio-test)
  photo: string; // Path to photo in /public/images/contributors/ or GitHub avatar URL (https://github.com/USERNAME.png)
  email: string; // Email address (same as github handle if not provided)
}

// List of playground contributors
// To add yourself: add your name, unique slug, photo, and email below
// Photos can be either:
// - Local: placed in /public/images/contributors/ (square images work best)
// - GitHub avatar: use https://github.com/USERNAME.png
// slug: short, unique owner slug based on your name (2-4 lowercase letters)
// email: your Faire email (e.g. first.last@faire.com) — required for automatic date tracking
export const contributors: Contributor[] = [
  {
    name: "Ajaybir",
    fullName: "Ajaybir Ratoul",
    slug: "ajr",
    photo: "",
    email: "ajaybir.ratoul@faire.com",
  },
  {
    name: "Alex",
    fullName: "Alex Tsarapkine",
    slug: "ats",
    photo: "",
    email: "alex.tsarapkine@faire.com",
  },
  {
    name: "Alier",
    fullName: "Alier Hu",
    slug: "ah",
    photo: "https://github.com/alierhu.png",
    email: "alier.hu@faire.com",
  },
  {
    name: "Ammad",
    fullName: "Ammad Shaikh",
    slug: "as",
    photo: "https://github.com/ammad-faire.png",
    email: "ammad.shaikh@faire.com",
  },
  {
    name: "Anatoly",
    fullName: "Anatoly Ostapenko",
    slug: "anatoly",
    photo: "https://github.com/ostapenko-me.png",
    email: "anatoly.ostapenko@faire.com",
  },
  {
    name: "Artyom",
    fullName: "Artyom Gabtraupov",
    slug: "ag",
    photo: "https://github.com/Artyom-G.png",
    email: "artyom.gabtraupov@faire.com",
  },
  {
    name: "Bella",
    fullName: "Bella Lu",
    slug: "bl",
    photo: "",
    email: "bella.lu@faire.com",
  },
  {
    name: "Benjamin",
    fullName: "Benjamin Chacon",
    slug: "bc",
    photo: "",
    email: "benjamin.chacon@faire.com",
  },
  {
    name: "Brandon",
    fullName: "Brandon Dang",
    slug: "bd",
    photo: "https://github.com/brandang.png",
    email: "brandon.dang1234@gmail.com",
  },
  {
    name: "Chris H",
    fullName: "Chris Handel",
    slug: "ch",
    photo: "https://github.com/chrishandel-faire.png",
    email: "chris.handel@faire.com",
  },
  {
    name: "Chris R",
    fullName: "Chris Rodriguez",
    slug: "cr",
    photo: "https://github.com/chrisleerod.png",
    email: "chrisleerod@gmail.com",
  },
  {
    name: "Erel",
    fullName: "Erel Gililov",
    slug: "eg",
    photo: "https://github.com/EternalErkle.png",
    email: "134109837+EternalErkle@users.noreply.github.com",
  },
  {
    name: "Eric",
    fullName: "Eric Ding",
    slug: "ed",
    photo: "https://github.com/eric-ding-faire.png",
    email: "xizheng.ding@faire.com",
  },
  {
    name: "Harshdip",
    fullName: "Harshdip Singh Deogan",
    slug: "hd",
    photo: "https://github.com/HarshdipD.png",
    email: "harshdipsdeogan@gmail.com",
  },
  {
    name: "Anelese",
    fullName: "Anelese Webski",
    slug: "awe",
    photo: "",
    email: "anelese.webski@faire.com",
  },
  {
    name: "Henry",
    fullName: "Henry Bullingham",
    slug: "hbul",
    photo: "",
    email: "henry.bullingham@faire.com",
  },
  {
    name: "Irene Ma",
    fullName: "Irene Ma",
    slug: "im",
    photo: "https://github.com/irenema-faire.png",
    email: "irene.ma@faire.com",
  },
  {
    name: "Jai",
    fullName: "Jai Mankoo",
    slug: "jm",
    photo: "https://github.com/jsmankoo.png",
    email: "jsmankoo@faire.com",
  },
  {
    name: "James",
    fullName: "James Bao",
    slug: "jba",
    photo: "https://github.com/JamesJBao.png",
    email: "106992809+JamesJBao@users.noreply.github.com",
  },
  {
    name: "Jasmine",
    fullName: "Jasmine Zhang",
    slug: "jz",
    photo: "",
    email: "jasmine.zhang@faire.com",
  },
  {
    name: "Jean",
    fullName: "Jean Yang",
    slug: "jy",
    photo: "https://github.com/jyang15.png",
    email: "jean@faire.com",
  },
  {
    name: "John A",
    fullName: "John Adesida",
    slug: "ja",
    photo: "https://github.com/jadesida.png",
    email: "john.adesida@faire.com",
  },
  {
    name: "John I",
    fullName: "John Intrater",
    slug: "ji",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/4389c379a56b7d72a8488e288866cb01c25fe97cf1016d5ed0b3d4033a8dc690.jpeg",
    email: "john.intrater@faire.com",
  },
  {
    name: "Justin",
    fullName: "Justin Li",
    slug: "jli",
    photo: "https://github.com/justinli0423.png",
    email: "justin.li0423@gmail.com",
  },
  {
    name: "Kevin",
    fullName: "Kevin Benscheidt",
    slug: "kev",
    photo: "https://github.com/kevinbenscheidt.png",
    email: "kevin.benscheidt@faire.com",
  },
  {
    name: "Kevin C",
    fullName: "Kevin Chik",
    slug: "kch",
    photo: "https://github.com/kchik-faire.png",
    email: "kevin.chik@faire.com",
  },
  {
    name: "Matthew",
    fullName: "Matthew Bojey",
    slug: "mb",
    photo: "https://github.com/matthewbojey.png",
    email: "matthew.bojey@faire.com",
  },
  {
    name: "Matthew",
    fullName: "Matthew Leandres",
    slug: "mle",
    photo: "https://github.com/mleandres-faire.png",
    email: "matthew.leandres@faire.com",
  },
  {
    name: "Michael",
    fullName: "Michael Zhang",
    slug: "mz",
    photo: "https://github.com/elphoun.png",
    email: "michael.zhang@faire.com",
  },
  {
    name: "Nakul",
    fullName: "Nakul Pathak",
    slug: "np",
    photo: "",
    email: "nakul.pathak@faire.com",
  },
  {
    name: "Pavlo",
    fullName: "Pavlo Kuzhel",
    slug: "pk",
    photo: "https://github.com/pkuzhel.png",
    email: "pavlo.kuzhel@faire.com",
  },
  {
    name: "Paulo",
    fullName: "Paulo Pinto",
    slug: "pp",
    photo: "https://github.com/paulopinto1086.png",
    email: "paulo.pinto@faire.com",
  },
  {
    name: "Pedro",
    fullName: "Pedro Alves",
    slug: "pa",
    photo: "https://github.com/pdralv.png",
    email: "pedro.goncalvesalves@faire.com",
  },
  {
    name: "Peiran",
    fullName: "Peiran Hong",
    slug: "ph",
    photo: "https://github.com/H2O-2.png",
    email: "peiran.hong@faire.com",
  },
  {
    name: "Riya",
    fullName: "Riya Pathak",
    slug: "rp",
    photo: "https://github.com/riya-faire.png",
    email: "riya.pathak@faire.com",
  },
  {
    name: "Ryan",
    fullName: "Ryan Lee",
    slug: "rl",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/1ccf64783b02784f0c815b43cbef42cdad8523ef4c93215fea9b2dc161a40c0a.jpeg",
    email: "ryan.lee@faire.com",
  },
  {
    name: "Gabe",
    fullName: "Gabe Kelley",
    slug: "gk",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/7d2b9aa79ab779361d8ca52ace428d4e6ba4db302d0f5ef64ce32aa3691e4627.jpeg",
    email: "gabe.kelley@faire.com",
  },
  {
    name: "Gabriela",
    fullName: "Gabriela Teran",
    slug: "gt",
    photo: "https://github.com/gabrielateran.png",
    email: "gabriela.teran@faire.com",
  },
  {
    name: "Samantha",
    fullName: "Samantha Yee",
    slug: "sy",
    photo: "https://github.com/SamanthaaYee.png",
    email: "cursoragent@cursor.com",
  },
  {
    name: "Shengchao",
    fullName: "Shengchao Wang",
    slug: "sw",
    photo: "https://github.com/PatrickWWWANG.png",
    email: "noreply@anthropic.com",
  },
  {
    name: "Taneisha",
    fullName: "Taneisha Lugo",
    slug: "tl",
    photo: "https://github.com/taneishalugo.png",
    email: "taneisha.lugo@faire.com",
  },
  {
    name: "Terence",
    fullName: "Terence Dickson",
    slug: "td",
    photo: "",
    email: "terence.dickson@faire.com",
  },
  {
    name: "Tim",
    fullName: "Tim Hoover",
    slug: "th",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/5685d62ed20d314810ebea5ed5ee1601b56b793284f8553672e3ab8da562fa82.png",
    email: "tim.hoover@faire.com",
  },
  {
    name: "Cristi",
    fullName: "Cristi Wallace",
    slug: "cw",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/f5e153b0e2ab6944297e163ed4e18932b661613b7be70420c410c8eab3ed3083.png",
    email: "cristi@faire.com",
  },
  {
    name: "Kevin G",
    fullName: "Kevin Geng",
    slug: "kg",
    photo: "",
    email: "kevin.geng@faire.com",
  },
  {
    name: "Kevin",
    fullName: "Kevin Lai",
    slug: "kl",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/f25c98eedb66433a657a7fb759b1f58dec28f633d45be28a2addbcdd3fabe276.jpeg",
    email: "kevin.lai@faire.com",
  },
  {
    name: "Jess",
    fullName: "Jess Brown",
    slug: "jb",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/68803a4353294ecf3f9708349c8a44c20eedebf0094437cf4d8d3483d005d6bf.jpeg",
    email: "jessica.brown@faire.com",
  },
  {
    name: "Jasmine",
    fullName: "Jasmine Shen",
    slug: "js",
    photo: "https://github.com/hellojasmineshen.png",
    email: "jasmine.shen@faire.com",
  },
  {
    name: "Martin",
    fullName: "Martin Sitar",
    slug: "ms",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/668599305e659dcdad34345ade86c46b8d5ec5eff474bf4d1172e23088b3c358.jpeg",
    email: "martin.sitar@faire.com",
  },
  {
    name: "Amy",
    fullName: "Amy Talus",
    slug: "at",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/3b15fd9bcb84d5dc71ce9c63b3f9bf5fa074f9a9932a8d4a18ed4475295967e0.png",
    email: "amy.henson@faire.com",
  },
  {
    name: "Rannie",
    fullName: "Rannie Teodoro",
    slug: "rt",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/f2cb384e95775c4b67cf18c7fb790019173b5e035d488d411af864c474454540.jpeg",
    email: "rannie.teodoro@faire.com",
  },
  {
    name: "Chris",
    fullName: "Chris Chappelle",
    slug: "cc",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/9823f53285becab8e68794d6843599c92107dca0c2821b13a56fc8e080e23d0d.jpeg",
    email: "chris.chappelle@faire.com",
  },
  {
    name: "Sam",
    fullName: "Sam Chieng",
    slug: "sc",
    photo: "https://github.com/samchieng.png",
    email: "sam.chieng@faire.com",
  },
  {
    name: "Jocelyn",
    fullName: "Jocelyn Teres",
    slug: "jt",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/408f9a3443287ab289a871ae98290471e75696e5cb901535849e749c3cb34612.png",
    email: "jocelyn.teres@faire.com",
  },
  {
    name: "Sharon",
    fullName: "Sharon Chan",
    slug: "shc",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/696f8c51e39baca25d6d8279ed5ec8bc29f18f8deb11b7825d11c42a1491d367.png",
    email: "sharon.chan@faire.com",
  },
  {
    name: "Austin",
    fullName: "Austin Dick",
    slug: "ad",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/44557fa0d02650cd6a2d43a5f809b0af6342649a1f1ae5c0de6e38bfa45bf28e.jpeg",
    email: "austin.dick@faire.com",
  },
  {
    name: "Em",
    fullName: "Em Thompson",
    slug: "et",
    photo: "https://github.com/emilythompson-design.png",
    email: "emily.thompson@faire.com",
  },
  {
    name: "Arthur",
    fullName: "Arthur Che",
    slug: "ac",
    photo: "https://github.com/chedigital.png",
    email: "arthur.che@faire.com",
  },
  {
    name: "Sophia",
    fullName: "Sophia Arriola-Gibson",
    slug: "sag",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/8269efdcfc3b83daa35db6facb96cc1cbaff0b421bfde912f856904c19fa7834.png",
    email: "sophia.gibson@faire.com",
  },
  {
    name: "Carolyn",
    fullName: "Carolyn Kao",
    slug: "ck",
    photo: "https://github.com/ckaofaire.png",
    email: "carolyn.kao@faire.com",
  },
  {
    name: "Brooklyn",
    fullName: "Brooklyn Brown",
    slug: "bb",
    photo: "https://github.com/brooklynO.png",
    email: "brooklyn.brown@faire.com",
  },
  {
    name: "Emily",
    fullName: "Emily Chen",
    slug: "ec",
    photo: "https://github.com/emilychen.png",
    email: "emily.chen@faire.com",
  },
  {
    name: "Fabio",
    fullName: "Fabio Carmo",
    slug: "fc",
    photo: "https://github.com/madcido.png",
    email: "fabio.carmo@faire.com",
  },
  {
    name: "Sophie O'Neill-Latulippe",
    fullName: "Sophie O'Neill-Latulippe",
    slug: "sol",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/4889699e0606e1554434814168441a24ff50a34b8bc64d1df58592f3abad2cf4.jpeg",
    email: "sophie.latulippe@faire.com",
  },
  {
    name: "AmyJin",
    fullName: "Amy Jin",
    slug: "aj",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/5e5e461617265fb29721344479c2c5ffa48dba8aad62ea553cca30142b41885b.png",
    email: "amy.jin@faire.com",
  },
  {
    name: "Marina",
    fullName: "Marina Liu",
    slug: "ml",
    photo: "https://github.com/marinaliu.png",
    email: "marina.liu@faire.com",
  },
  {
    name: "Abby",
    fullName: "Abby Mills",
    slug: "am",
    photo:
      "https://cdn.prerelease.faire.dev/fastly/eef29311ba894a3250b6479735ca70e367361c69fdb3a752fad06bb469a5590c.jpeg",
    email: "abby.mills@faire.com",
  },
  {
    name: "Abigail",
    fullName: "Abigail Waterston",
    slug: "aw",
    photo: "https://github.com/awaterston01.png",
    email: "abigail.waterston@faire.com",
  },
  {
    name: "Quentin",
    fullName: "Quentin Hsu",
    slug: "qh",
    photo: "https://github.com/qqlabs.png",
    email: "quentin.hsu@faire.com",
  },
  {
    name: "Lan Lam",
    fullName: "Lan Lam",
    slug: "ll",
    photo: "https://github.com/lanlam-faire.png",
    email: "lan.lam@faire.com",
  },
  {
    name: "Kasia",
    fullName: "Kasia Bedkowski",
    slug: "kb",
    photo: "https://github.com/kasiabedkowski.png",
    email: "kasia.bedkowski@faire.com",
  },
  {
    name: "Katherine",
    fullName: "Katherine Vidal",
    slug: "kv",
    photo: "https://github.com/katherinevidal.png",
    email: "katherine.vidal@faire.com",
  },
  {
    name: "Leon",
    fullName: "Leon Kempers",
    slug: "lk",
    photo: "https://github.com/leonkempers-faire.png",
    email: "leon.kempers@faire.com",
  },
  {
    name: "Reba",
    fullName: "Rebecca Gray",
    slug: "rg",
    photo: "https://ca.slack-edge.com/E07666GNCV7-U04SA4BT44E-a7b2c1ee2b69-512",
    email: "rebecca.gray@faire.com",
  },
  {
    name: "Remy",
    fullName: "Remy Gordon",
    slug: "remy",
    photo: "https://github.com/remygordon.png",
    email: "remy.gordon@faire.com",
  },
  {
    name: "Sanjay",
    fullName: "Sanjay Raman",
    slug: "sr",
    photo: "https://github.com/sanjayraman.png",
    email: "sanjay.raman@faire.com",
  },
  {
    name: "Sagar",
    fullName: "Sagar Patel",
    slug: "sp",
    photo: "https://github.com/sagarpatel-faire.png",
    email: "sagar.patel@faire.com",
  },
  {
    name: "Tanya Ma",
    fullName: "Tanya Ma",
    slug: "tm",
    photo: "https://github.com/tanyama.png",
    email: "tanya.ma@faire.com",
  },
  {
    name: "Tara",
    fullName: "Tara Rao-Pandit",
    slug: "trp",
    photo: "https://github.com/traopand.png",
    email: "tara.rao-pandit@faire.com",
  },
  {
    name: "Maggie",
    fullName: "Maggie Murphy",
    slug: "mm",
    photo: "https://github.com/maggiemurphy.png",
    email: "maggie.murphy@faire.com",
  },
  {
    name: "Michal",
    fullName: "Michal Jez",
    slug: "mj",
    photo: "https://github.com/MJez29.png",
    email: "michal.jez@faire.com",
  },
  {
    name: "Henrique",
    fullName: "Henrique Povedano",
    slug: "hp",
    photo: "https://github.com/henriquepovedano.png",
    email: "henrique.povedano@faire.com",
  },
  {
    name: "Kendra",
    fullName: "Kendra Conn",
    slug: "kc",
    photo: "https://github.com/kendraconn.png",
    email: "kendra.conn@faire.com",
  },
  {
    name: "Becca",
    fullName: "Becca Sabnani",
    slug: "bs",
    photo: "https://github.com/beccasabnani.png",
    email: "becca.sabnani@faire.com",
  },
  {
    name: "Leigh",
    fullName: "Leigh Jennings",
    slug: "lj",
    photo: "https://github.com/lnjennings.png",
    email: "leigh.jennings@faire.com",
  },
  {
    name: "Andrew",
    fullName: "Andrew Liu",
    slug: "al",
    photo: "https://github.com/andrew-liu-19.png",
    email: "andrew.liu@faire.com",
  },
  {
    name: "Catwu",
    fullName: "Cat Wu",
    slug: "cwu",
    photo: "https://github.com/catwu.png",
    email: "cat.wu@faire.com",
  },
  {
    name: "Geoff",
    fullName: "Geoff Beresford",
    slug: "gb",
    photo: "https://github.com/geoffberesford.png",
    email: "geoffrey.beresford@faire.com",
  },
  {
    name: "Lauren",
    fullName: "Lauren Blake",
    slug: "lb",
    photo: "https://github.com/laurenblake.png",
    email: "lauren.blake@faire.com",
  },
  {
    name: "Ben",
    fullName: "Ben Hamilton",
    slug: "bh",
    photo: "https://github.com/benhamilto.png",
    email: "benjamin.hamilton@faire.com",
  },
  {
    name: "Irene Limb",
    fullName: "Irene Limb",
    slug: "il",
    photo: "https://github.com/irenelimb-faire.png",
    email: "irene.limb@faire.com",
  },
  {
    name: "Shilpa",
    fullName: "Shilpa Subrahmanyam",
    slug: "ss",
    photo: "https://github.com/shilpaks.png",
    email: "shilpa.subrahmanyam@faire.com",
  },
  {
    name: "Kristin",
    fullName: "Kristin Yeh",
    slug: "ky",
    photo: "https://github.com/kristinyeh.png",
    email: "kristin@faire.com",
  },
  {
    name: "Olivia",
    fullName: "Olivia OLeary",
    slug: "oo",
    photo: "https://github.com/oliviaoleary.png",
    email: "olivia.oleary@faire.com",
  },
  {
    name: "Tom",
    fullName: "Tom Ma",
    slug: "tma",
    photo: "https://github.com/TommaMMC.png",
    email: "tom.ma@faire.com",
  },
  {
    name: "Tony",
    fullName: "Tony Chen",
    slug: "tc",
    photo: "https://github.com/tonychen.png",
    email: "tony.chen@faire.com",
  },
  {
    name: "Bronwyn",
    fullName: "Bronwyn Gemmill",
    slug: "bg",
    photo: "https://github.com/bronwyngemmill.png",
    email: "bronwyn.gemmill@faire.com",
  },
  {
    name: "Jeremy",
    fullName: "Jeremy Leclerc",
    slug: "jl",
    photo: "https://github.com/jeremy-leclerc-faire.png",
    email: "jeremy.leclerc@faire.com",
  },
  {
    name: "Brian",
    fullName: "Brian Solomon",
    slug: "bri",
    photo: "https://github.com/briansolomon.png",
    email: "brian.solomon@faire.com",
  },
  {
    name: "Korosh",
    fullName: "Korosh Ahangar",
    slug: "ka",
    photo: "https://github.com/ruhigesAuge.png",
    email: "korosh.ahangar@faire.com",
  },
  {
    name: "Trung",
    fullName: "Trung Nguyen",
    slug: "tn",
    photo: "https://github.com/chinhtrung.png",
    email: "chinhtrung596@gmail.com",
  },
  {
    name: "Uzair",
    fullName: "Uzair Ashraf",
    slug: "ua",
    photo: "https://github.com/uzairashraf.png",
    email: "uzair.ashraf@faire.com",
  },
  {
    name: "Harsha",
    fullName: "Harsha Yeddanapudy",
    slug: "hy",
    photo: "https://github.com/faire-harsha.png",
    email: "harsha.yeddanapudy@faire.com",
  },
  {
    name: "Pooja",
    fullName: "Pooja Jumani",
    slug: "pj",
    photo: "https://github.com/pjumani-f.png",
    email: "pooja.jumani@faire.com",
  },
  {
    name: "Max",
    fullName: "Max VanOstrillo",
    slug: "mv",
    photo: "https://github.com/max-vanostrillo-faire.png",
    email: "max.vanostrillo@faire.com",
  },
  {
    name: "Michael",
    fullName: "Michael Yen",
    slug: "my",
    photo: "https://github.com/michaelyen.png",
    email: "michael.yen@faire.com",
  },
  {
    name: "Nick",
    fullName: "Nick Howland",
    slug: "nh",
    photo: "https://github.com/nhowland.png",
    email: "nick.howland@faire.com",
  },
  {
    name: "Nikita",
    fullName: "Nikita Tashchilin",
    slug: "nt",
    photo: "https://github.com/aleveha.png",
    email: "nikita.tashchilin@faire.com",
  },
  {
    name: "Jia",
    fullName: "Jia Tu",
    slug: "jtu",
    photo: "https://github.com/jiajiabinx.png",
    email: "46426911+jiajiabinx@users.noreply.github.com",
  },
  {
    name: "MarkW",
    fullName: "Mark Widish",
    slug: "mw",
    photo: "https://github.com/mwidish.png",
    email: "mark.widish@faire.com",
  },
  {
    name: "Tom",
    fullName: "Tom Fischer",
    slug: "tf",
    photo: "https://github.com/tom-fischer.png",
    email: "tom.fischer@faire.com",
  },
  {
    name: "Vaibhav",
    fullName: "Vaibhav Singh",
    slug: "vsi",
    photo: "",
    email: "vaibhav.singh@faire.com",
  },
  {
    name: "Victoria",
    fullName: "Victoria Schuster",
    slug: "vs",
    photo: "https://github.com/vmschuster.png",
    email: "victoria.schuster@faire.com",
  },
  {
    name: "Vikas",
    fullName: "Vikas Lalwani",
    slug: "vikas",
    photo: "https://github.com/vikas-faire.png",
    email: "vikas.lalwani@faire.com",
  },
  {
    name: "Wahab",
    fullName: "Wahab Ahmad",
    slug: "wa",
    photo: "https://github.com/w28ahmad-faire.png",
    email: "wahab.ahmad@faire.com",
  },
  {
    name: "Wyatt",
    fullName: "Wyatt Hayman",
    slug: "wh",
    photo: "https://github.com/wyatthay.png",
    email: "wyatt.hayman@faire.com",
  },
  {
    name: "Yanwu",
    fullName: "Yanwu Gu",
    slug: "yg",
    photo: "https://github.com/yanwugu-faire.png",
    email: "yanwu.gu@faire.com",
  },
  {
    name: "Yuki",
    fullName: "Yuki Mo",
    slug: "ym",
    photo: "https://github.com/yukimo.png",
    email: "yukymo2014@gmail.com",
  },
  {
    name: "Quinn",
    fullName: "Quinn Budan",
    slug: "qb",
    photo: "",
    email: "quinn.budan@faire.com",
  },
  {
    name: "Jack",
    fullName: "Jack Guo",
    slug: "jg",
    photo: "https://github.com/jackguo336.png",
    email: "zhenghao.guo@faire.com",
  },
  {
    name: "Etienne",
    fullName: "Etienne Lamoureux",
    slug: "el",
    photo: "https://github.com/etiennemartin-faire.png",
    email: "etienne.lamoureux@faire.com",
  },
  {
    name: "Yikai",
    fullName: "Yikai Zhou",
    slug: "yz",
    photo: "https://github.com/yikaizhou252.png",
    email: "zhou.yikai76@gmail.com",
  },
  {
    name: "Mehul",
    fullName: "Mehul Pillai",
    slug: "mp",
    photo: "",
    email: "mehul.pillai@faire.com",
  },
  {
    name: "Chanyee",
    fullName: "Chanyee Kim",
    slug: "kim",
    photo: "https://github.com/chani9506.png",
    email: "chanyee.kim@faire.com",
  },
  {
    name: "Miranda",
    fullName: "Miranda Fitts",
    slug: "mf",
    photo: "https://github.com/miranda-fitts.png",
    email: "miranda.fitts@faire.com",
  },
  {
    name: "Dongpeng",
    fullName: "Dongpeng Liu",
    slug: "dl",
    photo: "https://github.com/dongpengliu.png",
    email: "dongpeng.liu@faire.com",
  },
  {
    name: "Jason",
    fullName: "Jason Hu",
    slug: "jh",
    photo: "https://github.com/jasonxfhu.png",
    email: "jason.hu@faire.com",
  },
  {
    name: "Will",
    fullName: "Will Chartrand",
    slug: "wc",
    photo: "https://github.com/willchartrand-faire.png",
    email: "will.chartrand@faire.com",
  },
  {
    name: "Haoyang",
    fullName: "Haoyang Ding",
    slug: "hyd",
    photo: "https://github.com/HaoyangDing.png",
    email: "haoyang.ding@faire.com",
  },
  {
    name: "Andy",
    fullName: "Andy Zhen",
    slug: "az",
    photo: "",
    email: "andy.zhen@faire.com",
  },
  {
    name: "Yao",
    fullName: "Yao Wang",
    slug: "yao",
    photo: "https://github.com/yaowang1999.png",
    email: "yao.wang@faire.com",
  },
  {
    name: "Liam",
    fullName: "Liam Toran",
    slug: "lt",
    photo: "https://github.com/liamtoran.png",
    email: "liam.toran@gmail.com",
  },
  {
    name: "Wei",
    fullName: "Wei Zhou",
    slug: "wz",
    photo: "https://github.com/weizhouc.png",
    email: "wei.zhou@faire.com",
  },
  {
    name: "Varun",
    fullName: "Varun Appaswami",
    slug: "va",
    photo: "",
    email: "varun.appaswami@faire.com",
  },
  {
    name: "Kelly",
    fullName: "Kelly Von Zup",
    slug: "kvz",
    photo: "https://github.com/kellyvonzup.png",
    email: "kelly.vonzup@faire.com",
  },
  {
    name: "Jabran",
    fullName: "Jabran Khan",
    slug: "jk",
    photo: "https://github.com/jabran-khan.png",
    email: "jabran.khan@faire.com",
  },
  {
    name: "Kevin Li",
    fullName: "Kevin Li",
    slug: "kli",
    photo: "https://github.com/kevinli-faire.png",
    email: "kevin.li@faire.com",
  },
  {
    name: "Kanika",
    fullName: "Kanika Arora",
    slug: "kar",
    photo: "",
    email: "kanika.arora@faire.com",
  },
];

/**
 * Find a contributor by name OR fullName.
 * This allows prototype owners to use either short names ("John") or full names ("John Intrater").
 */
export const findContributor = (
  ownerOrName: string
): Contributor | undefined => {
  return contributors.find(
    (c) => c.name === ownerOrName || c.fullName === ownerOrName
  );
};

/** Get the display name (fullName) for a prototype owner. */
export const getFullName = (ownerOrName: string): string => {
  return findContributor(ownerOrName)?.fullName || ownerOrName;
};

/** Get the short name (used for facepile filtering) for a prototype owner. */
export const getShortName = (ownerOrName: string): string => {
  return findContributor(ownerOrName)?.name || ownerOrName;
};
